var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("SAMSYS counters: "+_vm._s(_vm.commonCounters.length))]),_c('p',[_vm._v(_vm._s(_vm.commonCounters))])])}
var staticRenderFns = []

export { render, staticRenderFns }